import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
import axios from 'axios';
import { decode } from 'html-entities';

// components
import UberNav from '../navigaiton/UberNav';


function subNavEnter(e) {
  const t = e.currentTarget;
  // console.dir(t);
  t.classList.add('active');
  t.children[0].classList.add('active');
  t.children[1].classList.add('active');
}

function subNavExit(e) {
  const t = e.currentTarget;
  // console.dir(t);
  t.classList.remove('active');
  t.children[0].classList.remove('active');
  t.children[1].classList.remove('active');
}

export class MainNav extends Component  {
  state = {
    mainnav: []
  }

  componentDidMount() {
    window.addEventListener('load', this.subNavClicks);
    const getMainNav = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/4');

    Promise.all([getMainNav]).then(res => {
      // console.dir(res);
      this.setState({
        mainnav: res[0].data.items,
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.subNavClicks);
  }

  Navitem(props) {
    const url = (props.props.url.includes('?page_id')) ? 'https://www.usa.edu/degree-programs/' : props.props.url;

    if (!props.props.children) {
      return <li className={ props.props.classes }> <a href={ url }> { decode(props.props.title) } </a> </li>;
    } else {
      return <li className={ props.props.classes + ' hasSubnav' } onMouseEnter={subNavEnter} onMouseLeave={subNavExit}>
          <a href={ url }>
            { decode(props.props.title) }
          </a>
          <UberNav navlist={ props.props.object_slug } />
        </li>;
    }
  }

  // subNavClicks() {
  //   console.log('nav active');
  //   const subNavs = document.querySelectorAll('li.hasSubnav');
  //   console.dir(subNavs);

  //   subNavs.forEach(function (item) {
  //     item.addEventListener('mouseenter', function() {
  //       console.log('menu in');
  //       this.classList.add('active');
  //       this.children[0].classList.add('active');
  //       this.children[1].classList.add('active');
  //     });
  //   });

  //   subNavs.forEach(function (item) {
  //     item.addEventListener('mouseleave', function() {
  //       console.log('menu out');
  //       this.classList.remove('active');
  //       this.children[0].classList.remove('active');
  //       this.children[1].classList.remove('active');
  //     });
  //   });
  // }

  render() {
    const { mainnav } = this.state;

    return (
      <>
        <nav id="main-nav">
          <ul>
            {mainnav.map(nav =>
              // <li key={ nav.id } className={ nav.classes }>
              //   <a href={ nav.url.replace('https://www.usa.edu', '') }> { decode(nav.title) } </a>
              // </li>
              <this.Navitem props={nav} key={ nav.id } />
            )}
          </ul>
        </nav>
      </>
    );
  }
}

export default MainNav;